var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useEffect, useState } from "react";
import { useWebshopApiClient } from "@/react/Webshop/providers/WebshopApiClientProvider";
const useTemplate = (uuid, version) => {
    const webshopApiClient = useWebshopApiClient();
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    useEffect(() => {
        const fetchTemplateData = () => __awaiter(void 0, void 0, void 0, function* () {
            setLoading(true);
            setError(null);
            try {
                const templateData = yield webshopApiClient.getTemplateData(uuid, version);
                setData(templateData);
            }
            catch (err) {
                if (err instanceof Error) {
                    setError(err.message);
                    return;
                }
                // Hope we catch this somewhere else? Should never happen
                throw err;
            }
            finally {
                setLoading(false);
            }
        });
        fetchTemplateData();
    }, [uuid, version, webshopApiClient]);
    return [data, loading, error];
};
export default useTemplate;
